import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  NAME: (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const duck = createDuck("GET_PLANES", newActions, newReducers);

const getPlanesThunk = (localId, page=null, limit=null, estado=null, groupLabel=null) => {

  let url = `${baseUrl}/getPlanes/${localId}`
  if(!groupLabel && !estado && page && limit){
    url = url + `?page=${page}&limit=${limit}`
  }
  else if( !groupLabel && estado && page && limit){
    url = url + `?page=${page}&limit=${limit}&estado=${estado}`
  }

  else if(groupLabel && !estado && page && limit){
    url = url + `?page=${page}&limit=${limit}&groupLabel=${groupLabel}`
  }
  else if(estado && groupLabel){
    url = url + `?estado=${estado}&groupLabel=${groupLabel}`
  }
  else if(!estado && groupLabel){
    url = url + `?groupLabel=${groupLabel}`
  }
  else if(estado && !groupLabel){
    url = url + `?estado=${estado}`
  }
 
  return createThunk(axios, "get", duck.actions, url, null);
};


const createPlanDuck = createDuck("ADD_PLAN", newActions, newReducers);

const createPlanThunk = (data) => {
  let url = `${baseUrl}/createPlan`;
  return createThunk(axios, "post", createPlanDuck.actions, url, data);
};

const updatePlanDuck = createDuck("UPDATE_PLAN", newActions, newReducers);

const updatePlanThunk = (data) => {
  let url = `${baseUrl}/updatePlan`;
  return createThunk(axios, "post", updatePlanDuck.actions, url, data);
};

const getPlanByIdDuck = createDuck("GET_PLAN_BY_ID", newActions, newReducers);

const getPlanByIdThunk = (id) => {
  let url = `${baseUrl}/getPlan/${id}`;
 
  return createThunk(axios, "get", getPlanByIdDuck.actions, url, null);
};

const createSuscripcionDuck = createDuck("ADD_SUSCRIPCION", newActions, newReducers);

const createSuscripcionThunk = (data) => {
  let url = `${baseUrl}/createSuscripcion`;
  return createThunk(axios, "post", createSuscripcionDuck.actions, url, data);
};


const suscripcionesByUsuarioDuck = createDuck("SUSCRIPCIONES_BY_USUARIO", newActions, newReducers);

const suscripcionesByUsuarioThunk = (id, localId, page, limit) => {
  let url = `${baseUrl}/suscripcionesByUsuario/${id}/${localId}?page=${page}&limit=${limit}`;
  return createThunk(axios, "get", suscripcionesByUsuarioDuck.actions, url, null);
};

const deleteSuscripcionDuck = createDuck("DELETE_SUSCRIPCION", newActions, newReducers);

const deleteSuscripcionThunk = (data) => {
  let url = `${baseUrl}/deleteSuscripcion`;
  return createThunk(axios, "post", deleteSuscripcionDuck.actions, url, data);
};

const suscripcionesByLocalDuck = createDuck("SUSCRIPCIONES_BY_LOCAL", newActions, newReducers);

const suscripcionesByLocalThunk = (localId, page, limit, ci=null, nombre=null, estado=null) => {
  let url = `${baseUrl}/suscripcionesByLocal/${localId}?page=${page}&limit=${limit}`;
  if(ci){
    url = url + `&ci=${ci}`;
  }
  if(nombre){
    url = url + `&nombre=${nombre}`;
  }
  if(estado){
    url = url + `&estado=${estado}`;
  }
  return createThunk(axios, "get", suscripcionesByLocalDuck.actions, url, null);
};

const duckSuscripcionByCi = createDuck("GET_SUSCRIPCION_BY_CI", newActions, newReducers);

const getSuscripcionByCiThunk = (data) => {
  const url = `${baseUrl}/getSuscripcionLocalByCi`;
  return createThunk(axios, "post", duckSuscripcionByCi.actions, url, data);
};

const ajustarSuscripcionDuck = createDuck("AJUSTAR_SUSCRIPCION", newActions, newReducers);

const ajustarSuscripcionThunk = (data) => {
  const url = `${baseUrl}/ajustarSuscripcion`;
  return createThunk(axios, "post", ajustarSuscripcionDuck.actions, url, data);
};


export default {
  duck,
  getPlanesThunk,
  createPlanDuck,
  createPlanThunk,
  updatePlanDuck,
  updatePlanThunk,
  getPlanByIdDuck,
  getPlanByIdThunk,
  createSuscripcionDuck,
  createSuscripcionThunk,
  suscripcionesByUsuarioDuck,
  suscripcionesByUsuarioThunk,
  deleteSuscripcionDuck,
  deleteSuscripcionThunk,
  suscripcionesByLocalDuck,
  suscripcionesByLocalThunk,
  duckSuscripcionByCi,
  getSuscripcionByCiThunk,
  ajustarSuscripcionDuck,
  ajustarSuscripcionThunk,
};
